import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setProviderPortalList,
  setProviderPortalLoading,
  setProviderPortalModalClinicians
} from 'src/store/modules/admin'
import { getClinicians } from 'src/store/modules/common'
import { sendPasswordRestorationEmail } from 'src/store/modules/user'

import {
  PROVIDER_PORTAL_DELETE_MESSAGE,
  PROVIDER_PORTAL_GET_LIST,
  PROVIDER_PORTAL_GET_PATCH_DELETE_ITEM,
  PROVIDER_PORTAL_POST_ITEM,
  PROVIDER_PORTAL_RESET_PASSWORD_MESSAGE,
  PROVIDER_PORTAL_SAVE_MESSAGE,
  PROVIDER_PORTAL_UPDATE_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const getModalClinicians =
  (config = {}) =>
  async (dispatch) => {
    dispatch(setProviderPortalLoading())

    try {
      const items = await getClinicians(config)

      dispatch(setProviderPortalModalClinicians(items))
    } catch (err) {
      catchError(err)
    }
  }

export const fetchProviderPortalList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: PROVIDER_PORTAL_GET_LIST,
          ...config
        }
      })

      dispatch(setProviderPortalList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const saveProviderPortal =
  (config = {}) =>
  async () => {
    const { payload = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: PROVIDER_PORTAL_POST_ITEM
        },
        payload
      })

      showSuccessModal({
        content: PROVIDER_PORTAL_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateProviderPortal =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: PROVIDER_PORTAL_GET_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: PROVIDER_PORTAL_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteProviderPortal =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: PROVIDER_PORTAL_GET_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: PROVIDER_PORTAL_DELETE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const resetProviderPortalPassword =
  (email = '') =>
  async (dispatch) => {
    try {
      await dispatch(sendPasswordRestorationEmail(email))

      showSuccessModal({
        content: PROVIDER_PORTAL_RESET_PASSWORD_MESSAGE,
        centered: true,
        keyboard: false
      })
    } catch (err) {
      catchError(err)
    }
  }
